exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js!leaflet/dist/leaflet.css"), "");

// module
exports.push([module.id, "\n#map-container {\n    position: relative;\n    padding: 0;\n    height: 1000px;\n}\n", ""]);

// exports
